<template>
  <div class="fullHeight register">
    <mu-row>
      <mu-col desktop="30" tablet="25"></mu-col>
      <mu-col desktop="40" tablet="50" class="animated fadeInUp">
        <div class="logo">
          <img src="../../../static/logos/lcp-logo.svg" width="312" alt="">
        </div>
        <MessageBox :message-type="flashMessageType" :message="flashMessageBody" :title="flashMessageTitle"
                    style="padding: 0 15px" v-if="showFlashMessage"></MessageBox>
        <mu-card-text>
<!--          <CompleteSocialRegistration v-if="completingSocialRegistration"/>-->
          <InitialRegistration/>
        </mu-card-text>
      </mu-col>
      <mu-col desktop="30" tablet="25"></mu-col>
    </mu-row>
    <div class="testimonial">
      <mu-row>
        <mu-col desktop="50" tablet="50">
          <img src="../../../static/testimonial-reg.png" alt="Liz Before and After">
        </mu-col>
        <mu-col desktop="50" tablet="50">
          <div class="testimonial-block">
            <img src="../../../static/quote.svg" width="28" alt="Quote Icon">
            <div class="testimonial-text">
              <p>“I’m a vegetarian and lost 13kg (2st) and am in Type 2 Diabetes Remission”</p>
            </div>
            <div class="testimonial-from">
              <p>Liz</p>
              <p class="member">Member since 2019</p>
            </div>
          </div>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>
<script>
import {Objects} from '../../helpers/Utilities'
import SocialLoginMixin from '../../mixins/SocialLoginMixin'
import Alert from "../../components/Alert/Alert";
import MonthLocalizerMixin from '../../mixins/Localization/DateMonths'
import PasswordStrengthValidation from "../../components/PasswordStrengthValidation/PasswordStrengthValidation";
import InitialRegistration from "../../components/Registration/InitialRegistration";
import RegistrationMixin from "../../mixins/RegistrationMixin"
import CompleteSocialRegistration from "../../components/Registration/CompleteSocialRegistration";
import MessageBox from "../../components/FlashMessage/MessageBox";
import FlashMessageMixin from "../../mixins/FlashMessageMixin";
import AuthenticationManager from "../../helpers/AuthenticationManager";

const DobObject = Objects.DobObject;

export default {
  mixins: [MonthLocalizerMixin, SocialLoginMixin, RegistrationMixin, FlashMessageMixin],
  components: {MessageBox, CompleteSocialRegistration, Alert, PasswordStrengthValidation, InitialRegistration},

  mounted() {
    if (!this.completingSocialRegistration) {
      AuthenticationManager.clearSession();
    }

    this.$gtag.pageview('/register');
  },
  computed: {
    completingSocialRegistration: function () {
      const self = this;
      if (self.$store.state.user.scope) {
        return true;
      }
    },
    title: function () {
      if (this.model.offerCode !== null) {
        return `${this.$t('message.labelLetsGetStarted')}: 50% off`;
      }

      return this.$t('message.labelLetsGetStarted');
    },
    isValidAge: function () {
      if (this.dob.day && this.dob.month && this.dob.year) {
        let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
        let dob = moment(userDob);
        let ageRestrict = moment().subtract(18, 'years');
        let validAge = moment(dob).isBefore(ageRestrict);
        return validAge;
      }
    },
    confirmPassErr: function () {
      let self = this;
      let error = self.errors.first('passwordVerify')
      if (error === "The Confirm Password confirmation does not match.") {
        return 'Please enter passswords that match';
      } else {
        return error;
      }
    }
  },

}


</script>

<style lang="less">
div#register {
  background-image: url('../../../static/pw/hero-image.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: -400px;

  .loginButton {
    border: none;
    height: 3.5rem;
    border-radius: 4px;
    color: #fff;

    img {
      height: 40px;
      width: 40px;
    }

    &.darkTextButton {
      color: #898989;
    }

    &.buttonImageOnly {
      background-size: 60%;
      background-position: center;
      background-repeat: no-repeat;

      img {
        visibility: hidden;
      }
    }
  }

  .buttonWrap {
    margin-bottom: 10px;
  }

  #firstnameTxt, #surnameTxt {
    .mu-text-field-help {
      position: absolute!important;
    }
  }

  input:disabled {
    cursor: not-allowed;
  }
}

.regTitle {
  font-size: 24px !important;
  font-weight: 500 !important;
}

.mu-text-field.error .mu-text-field-label {
  color: #f44336 !important;
}

</style>
<style scoped lang="less">

.covid-banner {
  position: absolute;
  padding: 20px;
  background: #d83e38;
  top: 0;
  left: 0;
  width: 100%;

  p {
    font-family: 'Poppins';
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.17;
    text-align: center;
    color: #ffffff;
  }
}

a {
  text-decoration: underline !important;
}

.logo {
  margin: 75px 0 25px;
  @media screen and (max-width: 713px) {
    margin-top: 100px;
  }

  img {
    display: block;
    margin: 0 auto;
  }
}

.offer-banner {
  background: #f4ffe6;
  margin: 0 16px 1.5rem;
  padding: 1.5rem 2.25rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

  p {
    color: #000;

    sub {
      bottom: -.05em;
      color: #3c3c3c;
    }
  }

  i {
    vertical-align: sub;
    margin-right: 8px;
    color: #00aa00;
  }

  .title {
    font-family: 'Poppins';
    font-size: 1.25rem;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #000000;
  }

  .description {
    font-family: 'Poppins';
    font-size: 1.125rem;
    line-height: 1.33;
    letter-spacing: 0.01px;
    text-align: left;
    color: #000000;
  }
}

.testimonial {
  max-width: 790px;
  display: block;
  margin: 0 auto;

  .row {
    align-items: center;
    margin-bottom: 4rem;
  }

  img {
    width: 100%;
  }

  .testimonial-block {
    background: #FFF;
    padding: 1.1rem 1.813rem;
    border-radius: 0 8px 8px 0;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    @media screen and (max-width: 600px) {
      border-radius: 0 0 8px 8px;
      width: 90%;
      margin: 0 auto;
    }

    img {
      width: 1.75rem;
    }

    .testimonial-text {
      margin: 1rem 0;

      p {
        font-family: 'Poppins';
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 1.3;
        text-align: left;
        color: #000000;
      }
    }

    .testimonial-from {
      p {
        font-family: 'Poppins';
        font-size: 1rem;
        font-weight: bold;
        line-height: 1.38;
        text-align: left;
        color: #000;
        margin: .15rem 0;

        &.member {
          color: #0179d5;
          margin-bottom: 0;
        }
      }
    }
  }
}

.mu-card-text {
  padding-top: 0;
}

.mu-card-title.regTitle {
  font-size: 25px !important;
}

.regTitle {
  font-size: 24px;
  font-weight: 500;
}

.mu-card {
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  padding: 15px;
  margin-bottom: 25px;
}

.field {
  position: relative;

  .pw-field {
    margin-bottom: 0;
  }
}

.field .right-icon {
  position: absolute;
  top: 20px;
  right: 0;
}

.noAccount {
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 16px;
  color: #9B9B9B;
}

.fullHeight {
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}

.IsError {
  color: white;
  background: red;
  width: 100%;
  padding: 16px;
}

.privacyDisclaimer {
  position: relative;
  padding: 0 0 0 35px;

  .mu-checkbox {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Register.vue?3e2143f5